import SurgeonsPage from './SurgeonsPage';

export default SurgeonsPage;